import { h, Component } from 'preact';
import { Listing, REQUEST_IN_PROGRESS } from '../../../../../types';
import { PHOTO_PARAMS, ORIGINAL_IMAGE_HOST,  } from '../../../../../constants';

interface ListingEditorMultimediaSectionProps {
  listing?: Listing;
  isEditingPhotos?: boolean;
  photoUploadState?: string;
  isPending?: number;
  onEditPhotoToggle?: any;
  onCancelPhotoUpload?: any;
  onUploadPhotos?: any;
}

interface ListingEditorMultimediaSectionState {}

export class ListingEditorMultimediaSection extends Component<ListingEditorMultimediaSectionProps, ListingEditorMultimediaSectionState> {

  render() {
    const {
      listing,
      isEditingPhotos,
      isPending,
      onEditPhotoToggle, 
      photoUploadState,
      children 
    } = this.props;

    const carouselRef = `#hiListingCarousel-${ listing.propertyKey }`

    return (
      <div className="row mt-3">
        <div className="col-12">
          {
            !isEditingPhotos && (
              <div className="hi-listing-page__carousel-container" id="hiListingCarouselContainer">
                <div 
                  data-ride="carousel"
                  className="hi-listing-page__carousel hi-listing-page__carousel-property carousel slide hi-lazy"
                  id={ carouselRef.substring(1) }>

                  <ol className="carousel-indicators">
                    { listing.multimedia.map( (photo, index) => 
                      <li 
                        data-target={ carouselRef }
                        data-slide-to={ index }
                        className={ index == 0 ? 'active' : '' }>
                      </li>
                    )}
                  </ol>

                  <div className="carousel-inner">
                    { 
                      listing.multimedia && listing.multimedia.length > 0 ? listing.multimedia.map( (photo, index) => 
                      <div className={ 'carousel-item ' + (index == 0 ? 'active' : '') }>
                        <img 
                          className="hi-listing-page__carousel-img"
                          data-src={ `//${ORIGINAL_IMAGE_HOST}/${photo.media}` }
                          src={ `//${ORIGINAL_IMAGE_HOST}/${photo.media}` }/>
                      </div>
                      ) :
                      <div className='carousel-item active'>
                        <img className="hi-listing-page__carousel-img"
                          src={ `//${ORIGINAL_IMAGE_HOST}/noPhoto02.png?${PHOTO_PARAMS}` }/>
                      </div>
                    }
                  </div>
                  <a 
                    href={ carouselRef }
                    className="carousel-control-prev" 
                    role="button" 
                    data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true">
                    </span>
                    <span className="sr-only">Previostates</span>
                  </a>

                  <a
                    href={ carouselRef }
                    className="carousel-control-next" 
                    role="button" 
                    data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true">
                    </span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              </div>
            )
          }
          {
            listing.canEdit && !isEditingPhotos ? (
              <div className="d-flex justify-content-center mt-3">
                <button
                  disabled={ isPending == 1 || !listing.canEdit }
                  className="btn btn-outline-dark" 
                  onClick={ onEditPhotoToggle }
                  type="button">
                  Add/Remove Photos
                </button>
              </div>
            ) : null
          }
          
          { children }

          {
            isEditingPhotos && (
              <div className="d-flex mt-3 hi-postprop__actions__button-container">
              { photoUploadState == REQUEST_IN_PROGRESS &&
                <div className="mx-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              }
            </div>
            )
          }
        </div>
      </div>
    );
  }
}